function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { createStore, compose, applyMiddleware } from "redux";
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from "react-redux";
import { createEpicMiddleware } from "redux-observable";
import rootEpic from "./epics";
import rootReducer from "./reducers";
import ExtensionAPIMiddleware from "./utils/ExtensionAPIMiddleware";
import initialState from "./reducers/initialState";
import { PlayerAPIMiddleware } from "./utils/PlayerAPIMiddleware";
var epicMiddleware = createEpicMiddleware();
var middewares = [
    epicMiddleware,
    ExtensionAPIMiddleware,
    PlayerAPIMiddleware
];
var configureState = function(iS) {
    var composeEnhancers = // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    var store = createStore(rootReducer, iS, composeEnhancers(applyMiddleware.apply(void 0, _toConsumableArray(middewares))));
    // @ts-ignore
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        // @ts-ignore
        module.hot.accept("./reducers", function() {
            var nextRootReducer = require("../reducers/index");
            store.replaceReducer(nextRootReducer);
        });
    }
    epicMiddleware.run(rootEpic);
    return store;
};
var _Store = configureState(initialState);
export var useDispatch = function() {
    return useReduxDispatch();
};
export var useSelector = useReduxSelector;
export default _Store;
